import { Pipe, PipeTransform } from '@angular/core';
import { PersonInitialsSource, resolvePersonInitials } from '../functions/person.function';

/** The initials of a person for an avatar, or «-» where no name is known. */
@Pipe({
  name: 'getInitials',
})
export class GetInitialsPipe implements PipeTransform {
  public transform(user: PersonInitialsSource | null | undefined): string {
    return resolvePersonInitials(user) || '-';
  }
}
